import React from 'react';
import PropTypes from 'prop-types';

import {
  PictureRow,
  PictureThumb,
  PictureThumbImage,
  PictureThumbRemove,
} from './styles';
import texts from './texts.json';

const PictureThumbList = ({ pictures, onRemove }) => {
  if (!pictures.length) {
    return null;
  }

  return (
    <PictureRow>
      {pictures.map((picture) => (
        <PictureThumb key={picture.id}>
          <PictureThumbImage src={picture.dataUrl} alt={texts.pictureAlt} />
          <PictureThumbRemove
            type="button"
            onClick={() => onRemove(picture.id)}
            aria-label={texts.pictureRemove}
          >
            ×
          </PictureThumbRemove>
        </PictureThumb>
      ))}
    </PictureRow>
  );
};

PictureThumbList.propTypes = {
  pictures: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    dataUrl: PropTypes.string.isRequired,
  })).isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default PictureThumbList;
